export const isIFrame = (el: HTMLElement | null): el is HTMLIFrameElement =>
  el !== null && el.tagName === 'IFRAME';
